function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useQuery } from 'react-query';
import axios from 'axios';
import useApplicationState from '../hooks/useApplicationState';
import useGetResolutions from './useGetResolutions';
import { useMemo } from 'react';

var useDefaultsCache = () => {
  var {
    apiUrl,
    apiKey
  } = useApplicationState();
  var {
    data: fetchApplicationData
  } = useQuery(['fetchApplication', {
    apiUrl,
    apiKey
  }], _ref => {
    var {
      queryKey
    } = _ref;
    var {
      apiKey,
      apiUrl
    } = queryKey[1];
    return axios.request({
      method: 'get',
      baseURL: "".concat(apiUrl, "/applicationlayers"),
      headers: {
        'X-API-Key': apiKey || ''
      }
    }).then(response => {
      return response.data;
    });
  }, {
    enabled: !!(apiUrl && apiKey)
  });
  var resolutions = useGetResolutions();
  return useMemo(() => {
    if (!fetchApplicationData || !resolutions) {
      return {
        cachedDefaults: undefined
      };
    }

    return {
      cachedDefaults: _objectSpread(_objectSpread({}, fetchApplicationData), {}, {
        resolutions
      })
    };
  }, [fetchApplicationData, resolutions]);
};

export default useDefaultsCache;